import React from 'react';
import { connect, useSelector } from 'react-redux'
import { useState, useMemo, useEffect } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import CardHeader from '../../../containers/CardHeader'
import Form from '../../../containers/Form/Form'
import Select from "../../../containers/Form/Select";
import Button from '../../../containers/Form/Button';

import Moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_offer_dashboard_stats } from "../../../app/apiEndpoints"
import DataTable from "../../../containers/DataTable";
import { Card, Row, Col, FormGroup, FormLabel, Breadcrumb } from 'react-bootstrap'
import { tableTypes } from '../../../app/settings'

import OfferToolToggle from '../../../containers/OfferToolToggle';

const sortPids = (pids) => {
    return [...pids].sort((a, b) => {
        // Keep a "view all" placeholder (empty ID) pinned to the top
        if (a.ID === '' || a.ID === '0') return -1;
        if (b.ID === '' || b.ID === '0') return 1;
        return String(a.NAME).localeCompare(String(b.NAME), undefined, { sensitivity: 'base' });
    });
}

const OfferDashboard = (props) => {
    const toolID = 29
    const [tool, setTool] = useState({})

    const [offerType, setOfferType] = useState('glp1')

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)

    const [revStats, setRevStats] = useState([])
    const [impStats, setImpStats] = useState([])
    const [pids, setPids] = useState([])
    const [geos, setGeos] = useState([])

    //filters
    const [startDate, setStartDate] = useState(new Date(Moment().add(-1, 'days').format('MM/DD/YYYY')))
    const [endDate, setEndDate] = useState(new Date(Moment().format('MM/DD/YYYY')))
    const [curPid, setCurPid] = useState('')
    const [curGeo, setCurGeo] = useState('')
    const [curDevice, setCurDevice] = useState('')

    const tableFields = ["Path", "Total Requests", "Success #", "Failure #", "Success %", "Fail %", "Paid #", "Paid %", "Rev/Paid Lead", "Revenue", "Rev/Lead"]
    const tableFieldName = ["path", "total_requests", "success_count", "failure_count", "success_rate_percent", "failure_rate_percent", "paid_count", "paid_percent", "avg_rev", "tot_revenue", "avg_rev_lead"]
    const impFields = ["Total Impressions", "Total Started Form", "% Started Form", "Total Completed Form", "% Completed Form"]

    const [sortField, setSortField] = useState('total_requests')
    const [sortDirection, setSortDirection] = useState(1)

    const [runStatus, setRunStatus] = useState(1)

    useMemo(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
                setTool(data.tool)
            }
        }
        getDetails()
    }, [toolID, userID, companyID])

    useEffect(() => {
        const getStats = async () => {
            if(toolID > 0) {
                setRunStatus(2)
                const data = await toolsAPICall(tool_offer_dashboard_stats, { 'requester': userID, 'company': companyID, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'offerType': offerType })
                setRevStats(data.revstats)
                if(data.impressions) setImpStats(data.impressions)
                if(data.pids) setPids(sortPids(data.pids))
                if(data.geos) setGeos(data.geos)

                setRunStatus(0)
            }
        }
        if(runStatus === 1) {
            getStats()
        }
    }, [userID, companyID, curPid, curGeo, curDevice, startDate, endDate, offerType, runStatus])

    const tableData = () => {
        if(!revStats || revStats.length === 0) {
            return [];
        }

        // Sort values before mapping
        let values = [...revStats].sort((a, b) => {
            // Always move "TOTAL" to the bottom
            if (a.path === "TOTAL") return 1;
            if (b.path === "TOTAL") return -1;

            let aValue = a[sortField];
            let bValue = b[sortField];

            // Convert to number if field is numeric
            if (['total_requests','success_count','failure_count','paid_count'].includes(sortField)) {
                aValue = parseInt(aValue);
                bValue = parseInt(bValue);
            } else if (['success_rate_percent','failure_rate_percent','paid_percent','tot_revenue','avg_rev','avg_rev_lead'].includes(sortField)) {
                aValue = parseFloat(aValue);
                bValue = parseFloat(bValue);
            } else {
                aValue = String(aValue).toLowerCase();
                bValue = String(bValue).toLowerCase();
            }

            if (aValue < bValue) return sortDirection === 0 ? -1 : 1;
            if (aValue > bValue) return sortDirection === 0 ? 1 : -1;
            return 0;
        });

        let rows = [];
        values.forEach(row => {
            rows.push({'id': row.path, 'values': [
                row.path,
                row.total_requests,
                row.success_count,
                row.failure_count,
                row.success_rate_percent + '%',
                row.failure_rate_percent + '%',
                row.paid_count,
                row.paid_percent + '%',
                row.avg_rev ? '$' + parseFloat(row.avg_rev).toFixed(4) : '',
                '$' + row.tot_revenue,
                row.avg_rev_lead ? '$' + parseFloat(row.avg_rev_lead).toFixed(4) : '',
            ]});
        });
        return rows
    }

    const sortData = (field, direction) => {
        let index = tableFields.indexOf(field)

        setSortField(tableFieldName[index])
        setSortDirection(direction)
    }

    const impressionData = () => {
        if(!impStats || impStats.length === 0) {
            return [];
        }

        let rows = [];
        let rowid = 0;
        impStats.forEach(row => {
            rows.push({'id': `I_${rowid}`, 'values': [
                row.total_impressions,
                row.started_form,
                row.started_form_percent + '%',
                row.completed_form,
                row.completed_form_percent + '%',
            ]});
            rowid++;
        });
        return rows
    }

    const runFilter = async () => {
        setRevStats([]); setImpStats([]);

        setRunStatus(1)
    };

    const filterDate = (field, value) => {
        if(field === 1) setStartDate(value)
        else if(field === 2) setEndDate(value)
    }

    const filterOffer = (e) => {
        let { value } = e.target;
        setOfferType(value)
    }
    const filterPid = (e) => {
        let { value } = e.target;
        setCurPid(value)
    }
    const filterGeo = (e) => {
        let { value } = e.target;
        setCurGeo(value)
    }
    const filterDevice = (e) => {
        let { value } = e.target;
        setCurDevice(value)
    }

    if(!tool) return <></>

    if(!pids) return <>No Data</>

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
          <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
        </Breadcrumb>
            <Card>
            <OfferToolToggle title={tool.tool_name} description={tool.description} value={offerType} onChange={filterOffer} />
                <Form description={tool.description} noCard={true} >
                    <Row>
                        <Col md={6}>
                            <strong>Dates</strong>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={startDate}>Start Date</FormLabel>
                                <Col md={6}>
                                    <DatePicker id="startDate" name="startDate" selected={startDate} className="form-control" onChange={(date) => filterDate(1, date)} />
                                </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={endDate}>End Date</FormLabel>
                                <Col md={6}>
                                <DatePicker id="endDate" name="endDate" selected={endDate} className="form-control" onChange={(date) => filterDate(2, date)} />
                                </Col>
                                </Row>
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <strong>Filters</strong>
                    {pids.length === 0 ? "" :
                    <Select
                        value={curPid}
                        label="SUBPID"
                        name="pid"
                        formValues={pids}
                        useDefault={false}
                        onChange={filterPid}
                        validate="string"
                        colSize="6"
                    />}
                    {geos.length === 0 ? "" :
                    <Select
                        value={curGeo}
                        label="GEOS"
                        name="geo"
                        formValues={geos}
                        useDefault={false}
                        onChange={filterGeo}
                        validate="string"
                        colSize="6"
                    />}
                    <Select
                        value={curDevice}
                        label="DEVICES"
                        name="device"
                        formValues={[{'ID': "", 'NAME': "VIEW ALL DEVICES"}, {'ID': "mobile", 'NAME': "Mobile"}, {'ID': "desktop", 'NAME': "Desktop"}]}
                        useDefault={false}
                        onChange={filterDevice}
                        validate="string"
                        colSize="6"
                    />
                    </Col>
                    </Row>
                        {runStatus === 2 && <Card.Body>Loading Dashboard...</Card.Body> }
                        {runStatus === 0 && <>
                    <Row>
                        <Col md={12} className='text-center'>
                            <Button onClick={(e) => { e.preventDefault(); runFilter(); }} title="Filter Dashboard" className="primary" />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                        <CardHeader title="Offer Success" description="" />
                        <DataTable hover={false} tableID="suc" fieldNames={tableFields} dataRows={tableData()} tableSettings={tableTypes.None} hideTotal={true} sortData={sortData} defaultSortOrder={1} defaultSortColumn='Total Requests' />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12}>
                        <CardHeader title="Impressions" description="" />
                        <DataTable hover={false} tableID="imp" fieldNames={impFields} dataRows={impressionData()} tableSettings={tableTypes.None} hideTotal={true} />
                        </Col>
                    </Row>
                    </> }
                </Form>
                </Card>
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(OfferDashboard), "Offer Dashboard"));
